<template>
    <div v-if="!isMobile" class="w-100 d-flex justify-content-center">
        <video-player v-if="isHsl()" ref="videoPlayer" :options="playerOptions" @ready="onPlayerReadied" @timeupdate="onTimeupdate">
        </video-player>
        <video v-else class="video-player" autoplay loop muted poster="/imgext/bg-home-video.jpg" id="bgvid">
            <source :src="video" :type="type">
        </video>
    </div>
    <div v-else class="position-absolute image-cover w-100 image-cover" :style="`background-image: url(/imgext/bg-home-mobile.jpg); height: ${windowHeight-30}px;`">
    </div>
</template>

<script>
import {HOME_VIDEO} from '../../../../utils/config'
import MobileDetector from '../../../common/MobileDetector'

import videojs from 'video.js'
window.videojs = videojs
require('videojs-contrib-hls/dist/videojs-contrib-hls.js')

export default {
  name: 'HomeVideo2',
  mixins: [MobileDetector],
  data () {
    return {
      initialized: false,
      playerOptions: {
        // aspectRatio: '16:9',
        preload: true,
        overNative: true,
        autoplay: true,
        loop: true,
        controls: false,
        techOrder: ['html5'],
        sourceOrder: true,
        html5: { hls: { withCredentials: false } },
        sources: [
          {
            withCredentials: false,
            type: 'application/x-mpegURL',
            src: ''
          }
        ],
        poster: '/imgext/bg-home-video.jpg'
      }
    }
  },
  computed: {
    type () {
      return 'video/mp4'
    },
    video () {
      return HOME_VIDEO
    }
  },
  methods: {
    isHsl () {
      return HOME_VIDEO.indexOf('.m3u8') > 0
    },
    onPlayerReadied () {
      if (!this.initialized) {
        this.initialized = true
      }
    },
    onTimeupdate (e) {
      // console.log('currentTime', e.cache_.currentTime)
    }
  },
  mounted () {
    if (this.isHsl()) {
      this.playerOptions.sources[0].src = this.video
      // this.playerOptions.width = `100`
      this.playerOptions.width = `${this.windowWidth}px`
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/front/components/pages/layout/home/HomeVideo.vue